import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {selectedPresentationSelector} from '../../../../store/selectors/presentation.selectors';
import {selectedSlideSelector} from '../../../../store/selectors/slide.selectors';
import SectionTitle from '../../../elements/common/SectionTitle';
import Label from '../../../../incase-domain/components/label/Label';
import DropdownMenuCompact from '../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import Button from '../../../../incase-domain/components/button/Button';

interface SlideChangeProps {
    slideChange: {name: string; slideId: string} | undefined;
    setSlideChange: (slideChange: {slideId: string; name: string}) => void;
}
function SlideChange(props: SlideChangeProps): ReactElement {
    const presentation = useSelector(selectedPresentationSelector);
    const {slides} = presentation;
    const {t} = useTranslation();

    const currentSlide = useSelector(selectedSlideSelector);

    const {slideChange, setSlideChange} = props;
    const slidesWithDefault = [
        {name: t('designSidepanel.dontChangeSlide'), _id: ''},
        ...slides.filter((slide) => slide._id !== currentSlide._id),
    ];

    function mapSelectedToOption(item: {name: string; slideId: string}): {label: string; value: string} {
        return {label: item.name, value: item.slideId};
    }

    const slideItems = [
        slidesWithDefault.map((el) => ({
            label: el.name,
            onClick: () => {
                if (el && typeof el._id === 'string') setSlideChange({...slideChange, slideId: el._id, name: el.name});
            },
        })),
    ];

    return (
        <div>
            <SectionTitle label={t('designSidepanel.presentationFlow')} />
            <Label className="u-mb-1">{t('designSidepanel.slideChangeOnClick')}</Label>
            <DropdownMenuCompact width="full" items={slideItems}>
                <Button className="c-sidepanel__dropdown_button" trailing="solar:alt-arrow-down-linear" size="xs" variant="soft" fullWidth>
                    {(slideChange && slideChange.name !== '' ? mapSelectedToOption(slideChange).label : undefined) ||
                        t('designSidepanel.selectSlide')}
                </Button>
            </DropdownMenuCompact>
        </div>
    );
}

export default SlideChange;
